import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "mau_modal_cambiar_demarcacion",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "aria-modal": "true",
  "aria-label": "Cambiar demarcación",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "mau_modal_cambiar_demarcacion_header"
}
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "mau_modal_cambiar_demarcacion_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_7 = {
  class: "scroll-y",
  id: "mau_modal_cambiar_demarcacion_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_cambiar_demarcacion_header",
  "data-kt-scroll-wrappers": "#mau_modal_cambiar_demarcacion_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "alert alert-dismissible bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle fs-2hx text-primary me-4 mb-5 mb-sm-0" }, null, -1)
const _hoisted_11 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-12 fv-row" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-12 fv-row" }
const _hoisted_18 = { class: "modal-footer flex-center" }
const _hoisted_19 = {
  type: "reset",
  id: "mau_modal_cambiar_demarcacion_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_20 = ["data-kt-indicator", "disabled"]
const _hoisted_21 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_22 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("dialogs.cambiarDemarcacion.titulo")), 1),
          _hoisted_6
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                      "formularios.familiaDetalle.cambiarDemarcacion.instrucciones"
                    )), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("formularios.servicioDetalle.nuevaComarca.label")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.familiaComarcaId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.familiaComarcaId) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.text,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("formularios.servicioDetalle.mensajeAdicional.label")), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_input, {
                    rows: 3,
                    autosize: { minRows: 3 },
                    type: "textarea",
                    placeholder: " ",
                    modelValue: _ctx.mensaje,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensaje) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$t("dialogs.cancelButton")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_ctx.meta.valid,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("dialogs.okButton")), 1))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_24))
              : _createCommentVNode("", true)
          ], 8, _hoisted_20)
        ])
      ])
    ])
  ], 512))
}